<template>
  <div v-if="getDetailCourse" class="kartu-prakerja-detail min-h-screen shadow-lg">
    <div style="max-width: 480px" class="relative">
      <BlHeaderMv
        class="absolute top-0 w-full"
        icon="ico_back_android"
        title=""
        style="
          margin: 0 auto;
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 18.99%, rgba(0, 0, 0, 0.175719) 52.53%, rgba(0, 0, 0, 0.292346) 100%);
        "
        @click="onClickBack"
      />
    </div>
    <div class="w-full object-cover relative" style="height: 250px">
      <img
        :src="optimizeImageWidth(getDetailCourse.images[0].url)"
        :alt="getDetailCourse.name"
        class="w-full object-cover"
        style="height: 250px"
      />
      <ComingSoon v-if="prakerjaEmptyStock && getPrakerjaComingSoonToggle" data-testid="coming-soon" variation="subheading-18" />
    </div>

    <div
      v-if="prakerjaEmptyStock && getPrakerjaComingSoonToggle"
      class="p-16 qa-section-capacity-empty-information"
      style="background-color: #fff2e0"
    >
      <div class="flex items-start">
        <IcoAlert color="#FB8B01" class="mr-8" width="48" />
        <div class="w-full">
          <BlTextAv class="pb-4" variation="caption-12" tag="h2" weight="bold" style="color: #4d2309">
            Maaf, kelas sedang tidak tersedia
          </BlTextAv>

          <BlTextAv v-if="isReminderNotificationToggle" class="pb-8" variation="caption-12" style="color: #4d2309">
            Kamu bisa cari kelas lain atau aktifkan pengingat supaya dapat notifikasi saat kelas ini dibuka.
          </BlTextAv>
          <BlTextAv v-else class="pb-8" variation="caption-12" style="color: #4d2309">Coba cari kelas menarik lainnya, yuk!</BlTextAv>

          <div class="flex">
            <BlButtonAv
              :class="isReminderNotificationToggle && 'mr-12'"
              variation="outline"
              size="small"
              :fullwidth="isReminderNotificationToggle"
              style="flex: 1"
              @click="goToHomePage"
            >
              <BlTextAv variation="caption-12" weight="bold" style="color: #3d3d3d">Cari Kelas Lain</BlTextAv>
            </BlButtonAv>
            <BlButtonAv
              v-if="isReminderNotificationToggle"
              data-testid="subscribe-notif-button"
              variation="outline"
              size="small"
              fullwidth
              :is-loading="isLoadingReminder"
              style="flex: 1"
              @click="clickNotification"
            >
              <IcoCrossCheckMinor v-if="isSubscribeNotification" slot="icon" color="#2B4AC7" />
              <IcoNotificationMinor v-else slot="icon" />
              <BlTextAv variation="caption-12" weight="bold" :style="btnNotificationContent.color">
                {{ btnNotificationContent.text }}
              </BlTextAv>
            </BlButtonAv>
          </div>
        </div>
      </div>
    </div>

    <PrakerjaDetailPageHeader
      :course-type="courseType"
      :course="getDetailCourse"
      :is-review-exists="!!reviews.length"
      @showReviewSheet="showReviewSheet"
    />
    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

    <!-- Tentang Kelas -->
    <PrakerjaDetailExpandableSection title="Tentang kelas" :content="formattedDealDesc" />
    <!-- End of Tentang Kelas -->

    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid qa-separator-course-detail" />

    <BlFlexContainerMv class="qa-flex-container-course-detail" direction="row" align-items="center">
      <BlFlexItemAv>
        <BlTextAv variation="body-16" tag="h2" class="p-16" weight="bold">Jadwal kelas</BlTextAv>
      </BlFlexItemAv>
      <BlFlexItemAv>
        <BlCapsuleAv>Baru</BlCapsuleAv>
      </BlFlexItemAv>
    </BlFlexContainerMv>
    <BlAccordionMv v-for="(cs, i) in getDetailCourse.course_schedules" :key="i" :is-active="i === 0" class="qa-accordion-schedule">
      <template #header>
        <BlTextAv class="qa-txt-schedule-name" variation="body-14">{{ cs.schedule_name }}</BlTextAv>
      </template>
      <template v-if="!getIsSelfPaced" #content>
        <BlTextAv variation="body-14">Kamu wajib mengikuti kelas pada:</BlTextAv>
        <BlFlexContainerMv direction="row" align-items="flex-start" style="overflow-x: hidden">
          <BlFlexItemAv>
            <IcoTimeMinor class="mv-16" color="#B6B6B6" />
          </BlFlexItemAv>
          <BlFlexItemAv style="width: 100%">
            <BlTextAv variation="body-14" class="pt-16 pl-4 mb-12" weight="bold">Waktu</BlTextAv>
            <template v-if="cs.times.length === 1">
              <BlTextAv class="pl-4 qa-txt-time" variation="body-14">
                {{ cs.times[0].schedule_date | humanizeTimestamp }}, {{ cs.times[0].start_time }}-{{ cs.times[0].end_time }}
                {{ cs.times[0].timezone.toUpperCase() }}
              </BlTextAv>
            </template>
            <template v-else>
              <ul class="pl-28 m-0">
                <li v-for="(t, j) in cs.times" :key="j">
                  <BlTextAv class="qa-txt-times" variation="body-14">
                    {{ t.schedule_date | humanizeTimestamp }}, {{ t.start_time }}-{{ t.end_time }} {{ t.timezone.toUpperCase() }}
                  </BlTextAv>
                </li>
              </ul>
            </template>
          </BlFlexItemAv>
        </BlFlexContainerMv>
        <BlFlexContainerMv direction="row" align-items="flex-start" style="overflow-x: hidden">
          <BlFlexItemAv>
            <IcoLocationMinor class="mv-16" color="#B6B6B6" />
          </BlFlexItemAv>
          <BlFlexItemAv style="width: 100%">
            <BlTextAv class="pt-16 pl-4 mb-12" variation="body-14" weight="bold">Lokasi</BlTextAv>
            <BlTextAv class="pl-4 qa-txt-location" variation="body-14">
              {{ cs.address }}{{ courseType !== 'webinar' ? `, ${cs.city}, ${cs.province}` : '' }}
            </BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
        <BlFlexContainerMv direction="row" align-items="flex-start" style="overflow-x: hidden">
          <BlFlexItemAv>
            <IcoAccountBoxMinor class="mv-16" color="#B6B6B6" />
          </BlFlexItemAv>
          <BlFlexItemAv style="width: 100%">
            <BlTextAv class="pt-16 pl-4 mb-12" variation="body-14" weight="bold">Instruktur</BlTextAv>
            <BlTextAv class="pl-4 qa-txt-trainer" variation="body-14">{{ cs.trainer }}</BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
        <BlFlexContainerMv direction="row" align-items="flex-start" style="overflow-x: hidden">
          <BlFlexItemAv>
            <IcoCorporate class="mv-16" color="#B6B6B6" style="width: 90%" />
          </BlFlexItemAv>
          <BlFlexItemAv style="width: 100%">
            <BlTextAv class="pt-16 pl-4 mb-12" variation="body-14" weight="bold">Kapasitas</BlTextAv>
            <BlTextAv class="pl-4 qa-txt-capacity" variation="body-14">
              {{ cs.capacity }} Orang
              <template v-if="getCheckQuotaToggle && isRemainingCapacityAvailable(cs.schedule_code)">
                {{ getRemainingCapacity(cs.schedule_code) > 0 ? `(sisa ${getRemainingCapacity(cs.schedule_code)} slot)` : '(slot penuh)' }}
              </template>
            </BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
      </template>
      <template v-else #content>
        <BlFlexContainerMv direction="row" align-items="flex-start" style="overflow-x: hidden">
          <BlFlexItemAv>
            <IcoAccountBoxMinor class="mv-16" color="#B6B6B6" />
          </BlFlexItemAv>
          <BlFlexItemAv style="width: 100%">
            <BlTextAv class="pt-16 pl-4 mb-12" variation="body-14" weight="bold">Instruktur</BlTextAv>
            <BlTextAv class="pl-4 qa-txt-trainer" variation="body-14">{{ cs.trainer }}</BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
      </template>
    </BlAccordionMv>

    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

    <!-- Kurikulum -->
    <PrakerjaDetailExpandableSection title="Kurikulum" :content="formattedSkuDesc" />
    <!-- End of Kurikulum -->

    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

    <!-- Syarat dan Ketentuan -->
    <PrakerjaDetailExpandableSection title="Syarat dan Ketentuan" :content="formattedTnC" />
    <!-- End of Syarat dan Ketentuan -->

    <!-- Review (Ulasan Membantu) -->
    <div v-if="reviews.length" class="review-detail block-detail">
      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />
      <BlFlexContainerMv direction="row" align-items="center" justify-content="space-between" padding="16px">
        <BlTextAv variation="body-16" weight="medium">Ulasan membantu</BlTextAv>
        <div v-if="getDetailCourse.rating" class="flex items-center space-x-2">
          <IcoStarMinor class="rating__star" color="#FFA726" />
          <BlTextAv variation="body-16" weight="medium" class="rating__value" style="padding-right: 2px">
            {{ getDetailCourse.rating.value }}
          </BlTextAv>
        </div>
      </BlFlexContainerMv>

      <PrakerjaReview :data="reviews[0]" style="border: none; padding-top: 8px" />

      <BlFlexContainerMv
        v-if="reviews.length > 1"
        direction="row"
        align-items="flex-start"
        justify-content="space-between"
        padding="0 16px 16px 16px"
      >
        <BlTextAv weight="medium" color="link-01" class="qa-view-all-reviews-button" @click="showReviewSheet">Lihat semua</BlTextAv>
      </BlFlexContainerMv>
    </div>
    <!-- End of Review (Ulasan Membantu) -->

    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

    <div>
      <BlFlexContainerMv padding="16px">
        <BlCalloutMv variation="medium">
          Untuk mempermudah dan memperlancar pemberian sertifikat, diharapkan menggunakan email yang sama dengan yang terdaftar di prakerja
        </BlCalloutMv>
      </BlFlexContainerMv>
    </div>

    <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

    <!-- Footer -->
    <template v-if="isEnableTransact">
      <!-- delete soon -->
      <div
        v-if="isValidCapacity && !getPrakerjaComingSoonToggle"
        class="p-16 qa-section-capacity-empty-information"
        style="background-color: #fff2e0"
      >
        <div v-if="isValidCapacity" class="p-16 qa-section-capacity-empty-information" style="background-color: #fff2e0">
          <div class="flex items-center justify-between pb-20">
            <div>
              <BlTextAv class="pb-4" variation="body-16" tag="h2" weight="bold">Maaf, kelas ini sudah penuh</BlTextAv>
              <BlTextAv variation="body-14">Kamu bisa coba daftar di kelas lainnya yang masih tersedia.</BlTextAv>
            </div>
            <img src="https://s0.bukalapak.com/illustration/original/img_small_register_problem.png" style="width: 64px; height: 64px" />
          </div>
          <RouterLink to="/">
            <BlButtonAv fullwidth>Cari Kelas Lain</BlButtonAv>
          </RouterLink>
        </div>
      </div>
      <!-- end of delete soon -->

      <div class="sticky bottom-0">
        <div class="flex rounded-t-2xl bg-white items-center justify-between p-16 border-t border-0 border-gray-5 border-solid">
          <div>
            <BlTextAv variation="body-14" style="color: #81868f">Biaya kelas</BlTextAv>
            <BlTextAv :class="!isValidCapacity ? 'text-crimson-50' : undefined" class="qa-amount-course" variation="body-16" weight="bold">
              {{ getDetailCourse.discount.original_price | money }}
            </BlTextAv>
          </div>
          <BlButtonAv
            :disabled="prakerjaEmptyStock"
            class="qa-btn-choose-schedule"
            data-testid="pilih-jadwal-button"
            @click="onClickChooseSchedule"
          >
            {{ prakerjaEmptyStock ? 'Segera hadir' : 'Pilih jadwal' }}
          </BlButtonAv>
        </div>
      </div>
    </template>

    <div v-else class="prevent-transact-info sticky bottom-0 w-full bg-gray-90">
      <div class="flex items-center space-x-4 pv-12 ph-16">
        <BlTextAv color="inverse" weight="bold" class="leading-5">
          Kamu bisa mengikuti kelas ini setelah pendaftaran Kartu Prakerja dibuka.
        </BlTextAv>
        <IcoInfo color="#fff" class="transform scale-150" />
      </div>
    </div>
    <!-- End of Footer -->

    <BlSheetMv v-if="reviews.length > 1" :active.sync="isSheetShown.review" title="Ulasan membantu" class="sheet-review">
      <IcoBackAndroid slot="iconLeftNavBar" color="active-darker" />
      <div slot="content">
        <BlFlexContainerMv direction="row" justify-content="flex-start" padding="20px 16px" class="space-x-3">
          <div v-if="dealRating" class="h-9 items-center justify-center">
            <BlTextAv class="text-center" variation="heading-28" weight="medium">{{ dealRating }}</BlTextAv>
          </div>
          <div class="space-y-1">
            <BlTextAv variation="body-14">{{ getDetailCourse.name }}</BlTextAv>
            <div v-if="dealRating" class="flex items-center space-x-1">
              <IcoStarMinor
                v-for="i in Math.floor(dealRating)"
                :key="`star-${i}`"
                color="#FFA726"
                class="u-display-inline-block u-valign-middle qa-all-review-star"
                style="width: 16px; height: 16px"
              />
            </div>
          </div>
        </BlFlexContainerMv>

        <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

        <div class="review-detail block-detail">
          <BlFlexContainerMv
            direction="row"
            align-items="center"
            justify-content="space-between"
            padding="16px"
            class="border-b border-gray-5 border-solid"
          >
            <BlTextAv variation="body-16" weight="medium">Semua Ulasan</BlTextAv>
          </BlFlexContainerMv>
          <PrakerjaReview v-for="(review, index) in reviews" :key="`review-${index}`" :data="review" class="qa-all-review" />
        </div>
      </div>
    </BlSheetMv>

    <BlSheetMv :active.sync="isSheetShown.chooseSchedule" class="qa-sheet-choose-schedule" title="Pilih jadwal kelas" auto-height>
      <div slot="content" style="padding: 16px">
        <BlTextAv class="mb-20">Kamu wajib mengikuti kelas pada:</BlTextAv>

        <BlFlexContainerMv direction="column">
          <BlFlexItemAv v-for="(cs, i) in getDetailCourse.course_schedules" :key="i">
            <BlRadioAv
              v-model="courseScheduleCode"
              :native-value="cs.schedule_code"
              :disabled="isScheduleDisabled(cs)"
              class="qa-radio-schedule mb-8"
            >
              {{ cs.schedule_name }}
            </BlRadioAv>
            <template v-if="getCheckQuotaToggle">
              <div v-if="toggleStatus.quotaInfoRevampEnabled && !!quotaInfo" class="pl-32 mb-20">
                <BlCapsuleAv class="qa-capsule-quota-info" :variation="quotaInfo[cs.schedule_code].capsuleVariant">
                  {{ quotaInfo[cs.schedule_code].text }}
                </BlCapsuleAv>
              </div>
              <BlTextAv
                v-else-if="isRemainingCapacityAvailable(cs.schedule_code) && !getIsSelfPaced"
                :color="getRadioButtonCapacityInfoColor(cs.schedule_code)"
                class="mb-20 pl-32 qa-txt-capacity-info-radio-button"
              >
                {{ getRemainingCapacity(cs.schedule_code) > 0 ? `sisa ${getRemainingCapacity(cs.schedule_code)} slot` : 'slot penuh' }}
              </BlTextAv>
            </template>
          </BlFlexItemAv>
        </BlFlexContainerMv>

        <BlFlexContainerMv align-items="center" class="mt-48">
          <BlCheckboxAv v-model="isAgree" class="mr-4">
            {{ tncCheckboxCopy }}
            <BlLinkAv @click="goToTncPage">syarat dan ketentuan</BlLinkAv>
          </BlCheckboxAv>
        </BlFlexContainerMv>
        <BlButtonAv
          :disabled="!(isAgree && courseScheduleCode)"
          class="mt-20 ph-28 qa-btn-checkout"
          variation="primary"
          fullwidth
          @click="goToCheckout"
        >
          Lanjut
        </BlButtonAv>
      </div>
    </BlSheetMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {humanizeTimestamp} from '@bukalapak/toolbox-helper/date-helper';
import {money} from '@bukalapak/toolbox-helper/number-helper';
import {BlHeaderMv} from '@bukalapak/bazaar-guild-mweb';
import {BlButtonAv, BlCalloutMv, BlCheckboxAv, BlCapsuleAv, BlAccordionMv, BlRadioAv, BlLinkAv} from '@bukalapak/bazaar-mweb-latest';
import {
  IcoStarMinor,
  IcoInfo,
  IcoBackAndroid,
  IcoTimeMinor,
  IcoLocationMinor,
  IcoAccountBoxMinor,
  IcoCorporate,
  IcoAlert,
  IcoNotificationMinor,
  IcoCrossCheckMinor,
} from '@bukalapak/bazaar-visual-next';
import {optimizeImageWidth} from 'shared_js/image-helpers';
import Braze from 'shared_js/helpers/braze';
import xss from 'xss';
import BlSheetMv from '../components/temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import PrakerjaDetailPageHeader from '../components/PrakerjaDetailPage/PrakerjaDetailPageHeader.vue';
import PrakerjaDetailExpandableSection from '../components/PrakerjaDetailPage/PrakerjaDetailExpandableSection.vue';
import PrakerjaReview from '../components/PrakerjaReview/PrakerjaReview.vue';
import {TNC_CHECKBOX_COPY, TNC_CHECKBOX_FALLBACK} from '../config/app';
import ComingSoon from 'src/shared/components/ComingSoon';
import nativeHandler from 'src/shared/mixins/native-handler';

export default {
  name: 'PrakerjaDetailPage',
  components: {
    BlCheckboxAv,
    BlButtonAv,
    BlCalloutMv,
    BlHeaderMv,
    IcoStarMinor,
    IcoInfo,
    IcoBackAndroid,
    PrakerjaReview,
    PrakerjaDetailPageHeader,
    BlSheetMv,
    PrakerjaDetailExpandableSection,
    BlCapsuleAv,
    BlAccordionMv,
    IcoTimeMinor,
    IcoLocationMinor,
    IcoAccountBoxMinor,
    IcoCorporate,
    BlRadioAv,
    BlLinkAv,
    ComingSoon,
    IcoAlert,
    IcoNotificationMinor,
    IcoCrossCheckMinor,
  },
  filters: {money, humanizeTimestamp},
  mixins: [nativeHandler],
  data() {
    return {
      isAgree: false,
      courseScheduleCode: '',
      sku: null,
      isTncExpanded: false,
      isDealDescExpanded: false,
      isSkuDescExpanded: false,
      previewDescLength: 100,
      reviews: [],
      isSheetShown: {
        review: false,
        tncConfirmation: false,
        chooseSchedule: false,
      },
      quotas: [],
      qoutaInfo: null,
      toggleStatus: {
        quotaInfoRevampEnabled: false,
      },
      isReminderNotificationToggle: false,
      isLoadingReminder: false,
      isSubscribeNotification: false,
    };
  },
  computed: {
    ...mapGetters(['getPreviousPage', 'getCheckQuotaToggle']),
    ...mapGetters('courses', ['getCourses', 'getDetailCourse', 'getIsSelfPaced', 'getPrakerjaComingSoonToggle']),
    isEnableTransact() {
      return !!this.$store.state.dataServer?.toggle?.isEnableTransact;
    },
    dealRating() {
      return this.getDetailCourse?.rating?.value;
    },
    courseId() {
      const URL = this.$route.params.id.split('-');
      return Number.parseInt(URL.pop(), 10);
    },
    isPreviewableDealDesc() {
      return this.getDetailCourse.deal.description.length > this.previewDescLength + 20;
    },
    isPreviewableSkuDesc() {
      return this.getDetailCourse.description?.length > this.previewDescLength + 20;
    },
    isPreviewableTnC() {
      return this.getDetailCourse.deal.terms_conditions.length > this.previewDescLength + 20;
    },
    formattedDealDesc() {
      return xss(this.getDetailCourse.deal.description);
    },
    formattedSkuDesc() {
      return xss(this.getDetailCourse.description);
    },
    formattedTnC() {
      return xss(this.getDetailCourse.deal.terms_conditions);
    },
    isPreviewableAndSkuExpanded() {
      return this.isPreviewableSkuDesc && this.isSkuDescExpanded;
    },
    isPreviewableAndTncExpanded() {
      return this.isPreviewableTnC && this.isTncExpanded;
    },
    isPreviewableAndDealExpanded() {
      return this.isPreviewableDealDesc && this.isDealDescExpanded;
    },
    isOldURL() {
      const URL = this.$route.params.id.split('-');
      return Number.isInteger(parseInt(URL[0]));
    },
    isTotalRemainingCapacityFull() {
      const totalRemainingCapacity = this.quotas.reduce((accumulator, quota) => accumulator + quota.remaining_capacity, 0);
      return totalRemainingCapacity <= 0;
    },
    isRemainingCapacitySameLengthAsCourseSchedule() {
      return this.quotas.length === this.getDetailCourse.course_schedules.length;
    },
    isValidCapacity() {
      return this.getCheckQuotaToggle && this.isRemainingCapacitySameLengthAsCourseSchedule && this.isTotalRemainingCapacityFull;
    },
    courseType() {
      return this.getDetailCourse.course_type;
    },
    tncCheckboxCopy() {
      return TNC_CHECKBOX_COPY[this.courseType] || TNC_CHECKBOX_FALLBACK;
    },
    prakerjaEmptyStock() {
      return this.getDetailCourse.prakerja_remaining_stock === 0;
    },
    platform() {
      return window.location.origin?.includes('m.') ? 'bl_mobile_web' : 'bl_web';
    },
    btnNotificationContent() {
      return this.isSubscribeNotification
        ? {
            text: 'Pengingat aktif',
            color: 'color: #2B4AC7',
          }
        : {
            text: 'Ingatkan saya',
            color: 'color: #3d3d3d',
          };
    },
    isLoggedIn() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
    loginPageUrl() {
      const backUrl = encodeURIComponent(window.location.href);
      const {isAndroid, isWebview} = window.USER?.agent ?? {};
      const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
      return `${prefixHost}/login?comeback=${backUrl}`;
    },
  },
  watch: {
    isReminderNotificationToggle(val) {
      if (val) {
        this.$tracker.event({
          evn: 'vp_prakerja_remind_me',
          ui: window.USER.id36,
          session: this.$root.mixinSessionId,
          source: 'coupon_detail_page',
          action: 'view_remind_me_button',
          sku_name: this.getDetailCourse?.name,
        });
        if (this.isLoggedIn) {
          this.getCourseNotification();
        }
      }
    },
  },
  beforeMount() {
    this.init();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) return;
      if (!window.USER.agent?.isWebview) return;

      // Reload page when user navigate back after login
      window.location.reload();
    },
    optimizeImageWidth,
    async init() {
      if (this.isOldURL) {
        const URL = this.$route.params.id.split('-');
        const courseId = URL.shift();
        this.$router.replace({
          name: 'detail',
          params: {id: [...URL, courseId].join('-')},
          query: {...this.$route.query, referrer: this.$route.query.referrer},
        });
      }

      window.scrollTo(0, 0);

      this.getAllReviews(this.courseId);
      this.fetchReminderNotificationToggle();
      await this.$store.dispatch('courses/fetchCourseDetail', this.courseId);

      this.trackPrakerjaDetail();

      if (!this.getDetailCourse) {
        this.$router.push({name: 'landing', query: this.$route.query});
      }

      if (this.getDetailCourse.course_schedules.length === 1 && this.getDetailCourse.course_schedules[0].state === 'active') {
        this.courseScheduleCode = this.getDetailCourse.course_schedules[0].schedule_code;
      }

      if (this.getCheckQuotaToggle) {
        this.$api
          .getCapacity({id: this.courseId})
          .then(({data}) => {
            this.quotas = data;
            this.quotaInfo = this.getDetailCourse.course_schedules.reduce((prevSchedule, schedule) => {
              prevSchedule[schedule.schedule_code] = this.generateQuotaInfo(schedule, data);
              return prevSchedule;
            }, {});
          })
          .catch(() => {
            this.quotas = [];
            this.quotaInfo = null;
          });

        this.fetchQuotaRevampToggle();
      }
    },
    reload() {
      this.$store.dispatch('courses/fetchCourseDetail', this.courseId);
    },
    fetchQuotaRevampToggle() {
      this.$api
        .getNeoToggles({
          id: ['virtual_product/toggle/prakerja/quota_info_revamp'],
          platform: 'bl_mobile_web',
        })
        .then(({data}) => {
          if (data[0]) this.toggleStatus.quotaInfoRevampEnabled = data[0].active;
        })
        .catch(() => {}); // allow error
    },
    onClickNext() {
      this.isSheetShown.tncConfirmation = true;
      window.dataLayer?.push?.({
        event: 'facebook.AddToCart',
        AddToCartPayload: {
          contents: [{id: `prakerja_${this.getDetailCourse?.id}`, quantity: 1}],
          value: this.getDetailCourse?.discount.original_price,
          content_type: 'product',
          currency: 'IDR',
        },
      });
    },
    onClickChooseSchedule() {
      this.isSheetShown.chooseSchedule = true;
      window.dataLayer?.push?.({
        event: 'facebook.AddToCart',
        AddToCartPayload: {
          contents: [{id: `prakerja_${this.getDetailCourse?.id}`, quantity: 1}],
          value: this.getDetailCourse?.discount.original_price,
          content_type: 'product',
          currency: 'IDR',
        },
      });
    },
    sendGTMViewContent() {
      // CPAS needs
      window.dataLayer?.push?.({
        event: 'facebook.ViewContent',
        ViewContentPayload: {
          contents: [{id: `prakerja_${this.getDetailCourse?.id}`, quantity: 1}],
          content_ids: [`prakerja_${this.getDetailCourse?.id}`],
          content_type: 'product',
        },
      });

      window.dataLayer?.push?.({event: 'prakerja.ViewContent'});
    },
    sendFacebookCustomTracker() {
      if (window.fbq) {
        window.fbq('trackCustom', 'visit_pdp_prakerja', {
          product_id: this.getDetailCourse?.id,
          product_name: this.getDetailCourse?.name,
          category: this.getDetailCourse?.category.name,
          provider: this.getDetailCourse?.deal.merchant.name,
          total_price: this.getDetailCourse?.discount.original_price,
        });
      }
    },
    goToTncPage() {
      this.$router.push({name: 'tnc', query: this.$route.query});
    },
    onClickBack() {
      const previousDomain = document.referrer ? new URL(document.referrer)?.hostname : '';
      const currentDomain = window.location.hostname;

      this.backNative(() => {
        if (previousDomain === currentDomain || this.getPreviousPage.name) {
          this.$router.go(-1);
          return;
        }
        this.$router.push({name: 'landing'});
      });
    },
    async goToCheckout() {
      this.isSheetShown.chooseSchedule = false;
      this.isSheetShown.tncConfirmation = false;

      await this.$nextTick();

      if (this.isLoggedIn) {
        let query = {...this.$route.query, course_id: this.getDetailCourse.id, schedule_code: this.courseScheduleCode};
        this.$router.push({
          query,
          name: 'checkout-form',
        });
      } else {
        const currentQueryParams = window.location.search.replace('?', '');

        let queryParams = `course_id=${this.getDetailCourse.id}&schedule_code=${this.courseScheduleCode}`;
        const {isAndroid, isWebview} = window.USER?.agent ?? {};

        const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
        const encodedComebackUrl = window.encodeURIComponent(
          `${prefixHost}${process.env.BASE_PATH}/checkout?${queryParams}&${currentQueryParams}`
        );

        window.location.replace(`${prefixHost}/login?comeback=${encodedComebackUrl}`);
      }
    },
    trackPrakerjaDetail() {
      this.sendGTMViewContent();
      this.$tracker.event({
        evn: 'vp_prakerja_detail',
        source: this.$root.source,
        referrer: this.$route.query.referrer || this.$root.referrer,
        ui: window.USER.id36,
        sku_name: this.getDetailCourse?.name,
        session_id: this.$root.mixinSessionId,
        keyword: this.$route.query.keyword,
      });
      this.trackVisit();
      this.sendFacebookCustomTracker();
    },
    trackVisit() {
      Braze.sendEvent('prakerja_pdp_visit', {
        product_name: this.getDetailCourse?.name,
        category: this.getDetailCourse?.category.name,
        provider: this.getDetailCourse?.deal.merchant.name,
        total_price: this.getDetailCourse?.discount.original_price,
      });
    },
    getAllReviews(id) {
      this.$api
        .getReviews({deal_sku_id: id})
        .then(({data}) => {
          this.reviews = data;
        })
        .catch(() => {
          this.reviews = [];
        });
    },
    showReviewSheet() {
      this.isSheetShown.review = true;
    },
    getRemainingCapacity(scheduleCode) {
      return this.quotas.find((quota) => quota.schedule_code === scheduleCode)?.remaining_capacity || 0;
    },
    getRadioButtonCapacityInfoColor(scheduleCode) {
      const remainingCapacity = this.getRemainingCapacity(scheduleCode);
      if (remainingCapacity > 5) return 'primary';
      else if (remainingCapacity <= 5 && remainingCapacity > 0) return 'highlight-01';
      else return 'disabled';
    },
    isRemainingCapacityAvailable(scheduleCode) {
      return this.quotas.length > 0 && this.quotas.some((quota) => quota.schedule_code === scheduleCode);
    },
    isScheduleInactive(courseSchedule) {
      return courseSchedule.state === 'inactive';
    },
    isCapacityFull(scheduleCode) {
      return this.getCheckQuotaToggle && this.isRemainingCapacityAvailable(scheduleCode) && this.getRemainingCapacity(scheduleCode) <= 0;
    },
    isScheduleDisabled(courseSchedule) {
      return this.isScheduleInactive(courseSchedule) || this.isCapacityFull(courseSchedule.schedule_code);
    },
    generateQuotaInfo(schedule, qoutas) {
      // prevent unwanted array search for inactive schedule
      if (this.isScheduleInactive(schedule)) {
        return {
          capsuleVariant: 'secondary',
          text: 'Sedang tidak tersedia',
        };
      }

      const quotaData = qoutas.find((quota) => quota.schedule_code === schedule.schedule_code);
      if (!quotaData) {
        return {
          capsuleVariant: 'secondary',
          text: 'Sedang tidak tersedia',
        };
      }

      const capacity = quotaData.remaining_capacity;

      if (capacity > 5) {
        return {
          capsuleVariant: 'success',
          text: `Sisa ${capacity} slot`,
        };
      }

      if (capacity > 0) {
        return {
          capsuleVariant: 'warning',
          text: `Sisa ${capacity} slot`,
        };
      }

      return {
        capsuleVariant: 'secondary',
        text: 'Slot penuh',
      };
    },
    goToHomePage() {
      this.$router.push({path: '/'});
    },
    fetchReminderNotificationToggle() {
      this.$api
        .getNeoToggles({
          id: ['virtual_product/toggle/prakerja/user_reminder_notifications'],
          platform: this.platform,
        })
        .then(({data}) => {
          if (data[0]) this.isReminderNotificationToggle = data[0].active;
        })
        .catch(() => {
          this.isReminderNotificationToggle = false;
        }); // allow error
    },
    getCourseNotification() {
      this.isLoadingReminder = true;

      this.$api
        .getSubscribeStatus({id: this.courseId})
        .then(({data}) => {
          this.isSubscribeNotification = data.subscribe_state === 'SUBSCRIBED';
        })
        .catch(() => {
          this.isSubscribeNotification = false;
        })
        .finally(() => {
          this.isLoadingReminder = false;
        });
    },
    subscribeCourseNotification() {
      this.isLoadingReminder = true;
      this.$api
        .postSubscribeNotification({id: this.courseId})
        .then(() => {
          this.isSubscribeNotification = true;
          this.$store.dispatch('onSnackbarShow', {message: 'Kamu akan dapat notifikasi saat kelas dibuka.'});
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingReminder = false;
        });
    },
    unSubscribeCourseNotification() {
      this.isLoadingReminder = true;
      this.$api
        .deleteSubscribeNotification({id: this.courseId})
        .then(() => {
          this.isSubscribeNotification = false;
          this.$store.dispatch('onSnackbarShow', {message: 'Pengingat sudah dibatalkan.'});
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingReminder = false;
        });
    },
    clickNotification() {
      if (!this.isLoggedIn) {
        window.location.href = this.loginPageUrl;
        return;
      }
      if (this.isSubscribeNotification) {
        this.unSubscribeCourseNotification();
        return;
      }
      this.$tracker.event({
        evn: 'vp_prakerja_remind_me',
        ui: window.USER.id36,
        session: this.$root.mixinSessionId,
        source: 'coupon_detail_page',
        action: 'click_remind_me_button',
        sku_name: this.getDetailCourse?.name,
      });
      this.subscribeCourseNotification();
    },
  },
};
</script>

<style lang="scss" scoped>
.kartu-prakerja-detail {
  &::v-deep {
    .bl-header {
      background: none;
      z-index: 100;
      box-sizing: border-box;
      .bl-button.is-icon-only {
        background: none;
      }
      svg path {
        fill: #ffffff;
      }
    }
    .bl-sheet__icon {
      background: none;
    }

    .bl-sheet__nav-bar {
      max-width: 480px;
      height: auto;
      padding-top: 34px;
    }
  }
}
</style>
